"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tree;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("./context");

var _treeChildren = _interopRequireDefault(require("./treeChildren"));

var _treeContainerUl = _interopRequireDefault(require("./styled/treeContainerUl"));

var _getNode = _interopRequireDefault(require("./helpers/getNode"));

var _useKeyNavigation2 = _interopRequireDefault(require("./hooks/useKeyNavigation"));

var _useTreeNodesAsPlainList = _interopRequireDefault(require("./hooks/useTreeNodesAsPlainList"));

/**
 * A Tree is visualization of a structure hierarchy with nested elements. A branch can be expanded or collapsed or selected. This is a BETA version.
 * @category Layout
 */
function Tree(props) {
  var data = props.data,
      onNodeExpand = props.onNodeExpand,
      onNodeCheck = props.onNodeCheck,
      onNodeSelect = props.onNodeSelect,
      selectedNode = props.selectedNode,
      className = props.className,
      style = props.style,
      id = props.id,
      ariaLabel = props.ariaLabel,
      ariaLabelledBy = props.ariaLabelledBy;
  var visibleNodes = (0, _useTreeNodesAsPlainList["default"])(data);

  var _useKeyNavigation = (0, _useKeyNavigation2["default"])({
    visibleNodes: visibleNodes,
    selectedNode: selectedNode,
    onNodeSelect: onNodeSelect,
    onNodeExpand: onNodeExpand
  }),
      autoFocus = _useKeyNavigation.autoFocus,
      focusedNode = _useKeyNavigation.focusedNode,
      setFocusedNode = _useKeyNavigation.setFocusedNode,
      clearFocusedNode = _useKeyNavigation.clearFocusedNode,
      keyDownHandler = _useKeyNavigation.keyDownHandler;

  var treeData = Array.isArray(data) ? data : [];
  return /*#__PURE__*/_react["default"].createElement(_context.Provider, {
    value: {
      autoFocus: autoFocus,
      focusedNode: focusedNode,
      onPrivateFocusNode: setFocusedNode,
      onPrivateBlurNode: clearFocusedNode,
      onPrivateKeyDown: keyDownHandler
    }
  }, /*#__PURE__*/_react["default"].createElement(_treeContainerUl["default"], {
    className: className,
    style: style,
    id: id,
    role: "tree",
    "aria-labelledby": ariaLabelledBy,
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_treeChildren["default"], {
    data: treeData,
    onNodeExpand: onNodeExpand,
    onNodeCheck: onNodeCheck,
    nodePath: [],
    selectedNode: selectedNode,
    onNodeSelect: onNodeSelect
  })));
}

Tree.propTypes = {
  /** A array with the nodes of the Tree. This is a recursive shape that is used for render the nested nodes passed on children of the array.
   */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].node,
    icon: _propTypes["default"].node,
    isExpanded: _propTypes["default"].bool,
    isLoading: _propTypes["default"].bool,
    isChecked: _propTypes["default"].oneOf([true, false, 'indeterminate']),
    children: _propTypes["default"].array
  })),

  /** The action triggered when the user clicks in the tree node expand or collapse button. */
  onNodeExpand: _propTypes["default"].func,

  /** The action triggered when the user clicks in the tree node checkbox. */
  onNodeCheck: _propTypes["default"].func,

  /** The action triggered when the user clicks in the tree node label. */
  onNodeSelect: _propTypes["default"].func,

  /** The tree node name. */
  selectedNode: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** The id of the tree heading element. Set to the parent element of the tree who contains the tree nodes.
   * No need to use "ariaLabel" atribute if this one apply */
  ariaLabelledBy: _propTypes["default"].string,

  /** The label for the parent element of the tree who contains the tree nodes. Apply if no tree heading element present */
  ariaLabel: _propTypes["default"].string
};
Tree.defaultProps = {
  data: [],
  onNodeExpand: function onNodeExpand() {},
  onNodeCheck: function onNodeCheck() {},
  onNodeSelect: function onNodeSelect() {},
  selectedNode: undefined,
  className: undefined,
  style: undefined,
  id: undefined,
  ariaLabelledBy: undefined,
  ariaLabel: undefined
};
/**
 * Add documentation.
 * @public
 */

Tree.getNode = _getNode["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Tree/index.js
// module id = 0R15
// module chunks = 0